import React from 'react'
import Swal from 'sweetalert2'
import {dmClosure} from '../../../../../components/requests'
import {Tooltip} from 'react-tooltip'
import {toast} from 'react-toastify'

const PieceNotAvailable = ({
  clientId,
  idTypePiece,
  redirectToClientDemande,
  demandeId,
  idDemandePiece,
  filters,
  otherData,
  dataClientInfos,
  isAvailable,
  onPieceChange,
  setDemandeClient,
  haveMultiplePiece = false,
  pieces,
  setPieces,
  setClientDemandePieces
}) => {
  const contactedBy = otherData?.professionnel ? otherData?.contactedBy?.email ?? dataClientInfos?.email : dataClientInfos?.email

  // Verification si il faut envoyer un email ou non
  let envoiEmail: any = null

  const clotureConf = () => {
    Swal.fire({
      title: 'Attention',
      html: isAvailable
        ? (
          !haveMultiplePiece
          ? `<p>Vous allez clôturer cette demande pièce à l’état "Pièce non disponible" et notifier le client. Continuer?</p>`
          : `<div>
              <p>Vous allez clôturer cette demande de pièce comme indisponible.</p>
              <p>Souhaitez vous également notifier le client ?</p>
              <div style="display: flex;justify-content: center;align-items: center;gap: 1em;">
                <label>
                  <input type="radio" name="option" value="true">
                  Oui
                </label>
                <label>
                  <input type="radio" name="option" value="false" checked>
                  Non
                </label>
              </div>
            </div>`
        )
        : `<p>Vous allez rendre la pièce de nouveau disponible. Continuer?</p>`,
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
      preConfirm: () => {
        if (isAvailable && haveMultiplePiece) {
          const selected = document.querySelector<HTMLInputElement>('input[name="option"]:checked')
          if (!selected) return false
          envoiEmail = (selected.value === "true")
        }
        return true
      }
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToastMailSendNotAvalaible = toast.loading(
          isAvailable ? 'Marquage de la pièce comme non disponible...' : 'Marquage de la pièce comme de nouveau disponible...'
        )
        const statut = 'NON_DISPONIBLE'
        dmClosure(statut, clientId, idDemandePiece, contactedBy, isAvailable, envoiEmail)
          .then((response) => {
            if (response?.clientDemandePiece !== undefined) {
              toast.update(idToastMailSendNotAvalaible, {
                render: isAvailable ? 'La pièce a été marquée comme non disponible' : 'La pièce est de nouveau disponible',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
              if (response?.clientDemandePiece?.demande) setDemandeClient(response?.clientDemandePiece?.demande)
              if (response?.isClosure && response?.clientDemandePieces?.length > 0) {
                // Mise à jour des pièces à rechercher dans la liste des pièces en stock
                setPieces(
                  (prev) => prev?.map(
                    (prevItem) => response?.clientDemandePieces?.find(
                      (item) => item?.id === prevItem?.id
                    )
                  )
                )
                // Mise à jour complet la liste des pièces
                setClientDemandePieces(response?.clientDemandePieces)
              }
              onPieceChange(idDemandePiece, !isAvailable, envoiEmail)
            }
          })
          .catch(() => {
            toast.update(idToastMailSendNotAvalaible, {
              render: 'Erreur lors du marquage de la pièce',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
          })
          .finally(() => envoiEmail = null)
      }
    })
  }

  return (
    <>
      <div className='text-end'>
        <button
          type='button'
          className={`btn btn-light-${isAvailable ? 'danger' : 'primary'} border border-${
            isAvailable ? 'danger' : 'primary'
          } d-flex gap-4 align-items-center`}
          // style={{
          //   border: '1px solid #e5f5bb',
          // }}
          onClick={() => {
            clotureConf()
          }}
          data-tooltip-id='tooltip'
          data-tooltip-content={isAvailable ? 'Retour client : pièce non disponible' : 'Rendre la pièce de nouveau disponible'}
          data-tooltip-place='top'
          disabled={pieces?.length === 0}
        >
          {isAvailable && (
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 256 256'>
              <g fill='#ff6161'>
                <path d='M216 128a88 88 0 1 1-88-88a88 88 0 0 1 88 88' opacity='0.2' />
                <path d='m198.24 62.63l15.68-17.25a8 8 0 0 0-11.84-10.76L186.4 51.86A95.95 95.95 0 0 0 57.76 193.37l-15.68 17.25a8 8 0 1 0 11.84 10.76l15.68-17.24A95.95 95.95 0 0 0 198.24 62.63M48 128a80 80 0 0 1 127.6-64.25l-107 117.73A79.63 79.63 0 0 1 48 128m80 80a79.55 79.55 0 0 1-47.6-15.75l107-117.73A79.95 79.95 0 0 1 128 208' />
              </g>
            </svg>
          )}
          {isAvailable ? 'Non disponible' : 'Rendre de nouveau disponible'}
        </button>
        <Tooltip id='tooltip' />
      </div>
    </>
  )
}

export {PieceNotAvailable}
